import { IDates } from "../types/SearchAvalilableTimes";

const emptySlot = {
  timeStart: "-",
  timeEnd: "-",
  idSchedule: "-",
  tipo: "-",
  dateStart: "-",
  dateEnd: "-",
};

/**
 * Equaliza todos os dias no maior número de agendas do conjunto (mínimo 5),
 * preenchendo com slots vazios — mesmo formato usado pelo AgendaCard.
 */
export const serializeAgenda = (dates: IDates[]): IDates[] => {
  if (!dates || dates.length === 0) return [];

  const maxLength = dates.reduce((a, b) => Math.max(a, b.agendas.length, 5), 0);
  if (maxLength === 0) return [];

  return dates.map((day) => {
    const agendas = [...day.agendas];
    if (agendas.length < maxLength) {
      agendas.push(...Array(maxLength - agendas.length).fill(emptySlot));
    }
    return { ...day, agendas };
  });
};
